import { useRef, useMemo } from 'react'
import { Instance, Instances } from '@react-three/drei'
import { useFrame } from '@react-three/fiber'
import { useLoader } from '@react-three/fiber'
import { TextureLoader } from 'three'
export default function CloudInstances({ count = 100 }) {
  const instancesRef = useRef()
  const cloudsRef = useRef([]) 
const map = useLoader(TextureLoader, '/assets/cloud.png')

  const cloudData = useMemo(() => {
    return Array.from({ length: count }).map(() => ({
      position: [
        Math.random() * 100 - 50,
        Math.random() * 20 - 20,  
        -Math.random() * 200, 
      ],
      scale: Math.random() * 3 + 1,
      speed: Math.random() * 0.1 + 0.1, 
    }))
  }, [count])

  useFrame(() => {
    if (!cloudsRef.current.length) return

    cloudsRef.current.forEach((cloud, i) => {
      if (!cloud) return
      cloud.position.z += cloudData[i].speed
      
      if (cloud.position.z > 10) {
        cloud.position.z = -Math.random() * 200 - 100;
        cloud.position.x = Math.random() * 100 - 50
        cloud.position.y = Math.random() * 10
      }
    })
  })



  return (
    <Instances
      ref={instancesRef}
      limit={count}
      castShadow
    >
      <planeGeometry args={[5, 5]} />
      <meshStandardMaterial 
        color='#775c88' 
        transparent 
        opacity={0.5} 
        depthWrite={false} 
        map={map}
      />
      {/* <CloudMaterial /> */}
      {cloudData.map((data, i) => (
        <Instance
          key={i}
          ref={(ref) => (cloudsRef.current[i] = ref)} // Track each instance
          position={data.position}
          scale={data.scale}
        />
      ))}
    </Instances>
  )
}

